/** Contenedor de la landing con menos margen lateral y más ancho útil. */
export const CHERRY_SOFTWARE_CONTAINER_PROPS = {
  maxWidth: { sm: 720, md: 1280, lg: 1400 },
  width: '100%',
  margin: '0 auto',
  paddingX: { xs: 1.5, sm: 2 },
  paddingY: { xs: 4, sm: 5, md: 7 },
};
